module.exports = __webpack_public_path__ + "static/img/appqrcode.754e332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appqrcode.png
// module id = iHDh
// module chunks = 51